module.exports = {
  language: {
    name: 'English'
  },
  user: {
    login: '確定',
    cancel: '取消',
    loginUsername: '請先登錄角色ID',
    server: '請選擇大區',
    activeTitle: '活躍禮包',
    activeTiem: '活躍時間',
    name: '角色名字',
    level: '等級',
    claim: '領取',
    purchase: '購買',
    rule: '活動規則',
    imgIdPrompt: '找不到你的角色ID?',
    promptInfo: '請輸入數字',
    errorNoInfo: '此大區沒有該用戶',
    receive: '领取',
    id: '玩家  ID',
    logout: '注销',
    title: '選擇大區',
    infoTitle: '提示'
  }
}
